import { defineMessages, pluralPl } from '../messages'

export const passwordMessages = defineMessages(
  {
    ruleText: 'Minnst 10 stafir, með hástaf, lágstaf og tölu.',
    error: 'Lykilorð verður að vera minnst 10 stafir og innihalda hástaf, lágstaf og tölu.',
    mismatch: 'Lykilorðin stemma ekki.',
    checkLength: (n: number) => `Minnst ${n} stafir`,
    checkUpper: 'Einn hástafur (A–Ö)',
    checkLower: 'Einn lágstafur (a–ö)',
    checkDigit: 'Ein tala (0–9)',
    checkMatch: 'Lykilorðin stemma',
  },
  {
    en: {
      ruleText: 'At least 10 characters, with an uppercase letter, a lowercase letter and a number.',
      error: 'The password must be at least 10 characters long and contain an uppercase letter, a lowercase letter and a number.',
      mismatch: 'The passwords do not match.',
      checkLength: (n: number) => `At least ${n} characters`,
      checkUpper: 'One uppercase letter (A–Z)',
      checkLower: 'One lowercase letter (a–z)',
      checkDigit: 'One number (0–9)',
      checkMatch: 'The passwords match',
    },
    pl: {
      ruleText: 'Co najmniej 10 znaków, w tym wielka litera, mała litera i cyfra.',
      error: 'Hasło musi mieć co najmniej 10 znaków i zawierać wielką literę, małą literę oraz cyfrę.',
      mismatch: 'Hasła nie są zgodne.',
      checkLength: (n: number) => `Co najmniej ${n} ${pluralPl(n, 'znak', 'znaki', 'znaków')}`,
      checkUpper: 'Jedna wielka litera (A–Z)',
      checkLower: 'Jedna mała litera (a–z)',
      checkDigit: 'Jedna cyfra (0–9)',
      checkMatch: 'Hasła są zgodne',
    },
  }
)
